import { render, staticRenderFns } from "./MyFeed.vue?vue&type=template&id=4fd16534&scoped=true&"
import script from "./MyFeed.vue?vue&type=script&lang=js&"
export * from "./MyFeed.vue?vue&type=script&lang=js&"
import style0 from "./MyFeed.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MyFeed.vue?vue&type=style&index=1&id=4fd16534&lang=scss&scoped=true&"
import style2 from "./MyFeed.vue?vue&type=style&index=2&id=4fd16534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd16534",
  null
  
)

export default component.exports